import {firestore} from '../firebaseIndex'

///////////////////////////////////////////////////////////////////////////////
export const addFailureType = async (domainId, contractId, data ) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId).collection('failuretypecollection')
            .add(data);
        const newdata = {
            ...data,
            id: res.id,
        }
        return newdata
    } catch (e) {
        console.log("addFailureType error: ", e)
        return { error: e }
    }
}



///////////////////////////////////////////////////////////////////////////////
export const getFailureTypeById = async (domainId, contractId, failuretypeId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('failuretypecollection')
            .doc(failuretypeId)
            .get()

        const firebaseData = res.data()
        const data = {
            ...firebaseData,
            id : res.id,
        }
        return data;
    } catch (e) {
        console.log("getFailureType error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const getFailureTypeList = async (domainId, contractId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('failuretypecollection')
            .get();

        const failuretypeList = res.docs.map(doc => {
            const firebaseData = doc.data()
            const data = {
                ...firebaseData,
                id: doc.id,
            }
            return data
        })
        return failuretypeList;
        
    } catch (e) {
        console.log("getFailureTypeList error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const editFailureType = async (domainId, contractId, failuretypeId, data) => {
    try {
        const failuretype =  firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('failuretypecollection')
            .doc(failuretypeId);

        const res = await failuretype.set(data)
            .then( () => {
                console.log("editFailureType - edit successfully")
                return data
            }).catch( error => {
                console.log("editFailureType - edit error: ", error)
                return {error: error}
            });

        return res
    }  catch (e) {
        console.log("editFailureType error: ", e)
        return { error: e }
    }
}


///////////////////////////////////////////////////////////////////////////////
export const deleteFailureType = async (domainId, contractId, failuretypeId) => {
    try {
        const res = await firestore.collection('DOMAINS')
            .doc(domainId).collection('contracts')
            .doc(contractId)
            .collection('failuretypecollection')
            .doc(failuretypeId).delete();
        return res
    }  catch (e) {
        console.log("deleteFailureType error: ", e)
        return { error: e }
    }
}


